import React from "react"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody } from "material-ui"
import Table from "../../../components/common/Table"
import strings from "../../../localization/strings"
import { IScheduleShift } from "../../../models"
import AccountStore from "../../../stores/AccountStore"
import * as timeHelper from "../../../helpers/timeHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import * as permissionHelper from "../../../helpers/permissionHelper"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import { checkPositionFieldAvailable } from "../../../helpers/positionHelper"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"
import { checkPhaseFieldAvailable } from "../../../helpers/punchHelper"
interface IProps {
	shiftTemplates: IScheduleShift[]
	selectedShiftTemplates: IScheduleShift[]
	handleUpdate(shiftTemplate: IScheduleShift): void
	handleSelect(shiftTemplates: IScheduleShift[]): void
}

const ShiftTemplatesTable: React.SFC<IProps> = (props: IProps) => {
	return (
		<div style={{ position: "relative" }} >
			<Table
				readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.DeleteAccountSchedule)}
				allowClickRow={permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule)}
				items={props.shiftTemplates}
				selectedItems={props.selectedShiftTemplates}
				handleClickRow={props.handleUpdate}
				handleSelect={props.handleSelect}
			>
				<TableHeader>
					<TableRow>
						<TableHeaderColumn className="TextOverflow" title={strings.Name} style={{ textAlign: "left", paddingLeft: 5, paddingRight: 5 }}>{strings.Name}</TableHeaderColumn>
						<TableHeaderColumn className="TextOverflow" title={strings.Description} style={{ textAlign: "left", paddingLeft: 5, paddingRight: 5 }}>{strings.Description}</TableHeaderColumn>
						<TableHeaderColumn className="TextOverflow" title={strings.Hierarchy} style={{ textAlign: "left", paddingLeft: 5, paddingRight: 5 }}>{strings.Hierarchy}</TableHeaderColumn>
						{AccountStore.getJobsEnabled() && [
							<TableHeaderColumn className="TextOverflow" title={checkJobFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Job} style={{ textAlign: "left", paddingLeft: 5, paddingRight: 5 }} key="job">{checkJobFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Job}</TableHeaderColumn>,
							<TableHeaderColumn className="TextOverflow" title={strings.Phase} style={{ textAlign: "left", paddingLeft: 5, paddingRight: 5 }} key="phase">{checkPhaseFieldAvailable("singular") ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel}` : strings.Phase }</TableHeaderColumn>
						]}
						<TableHeaderColumn className="TextOverflow" title={checkPositionFieldAvailable('singular') ?  AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel: strings.Position} style={{ textAlign: "left", paddingLeft: 5, paddingRight: 5 }}>{checkPositionFieldAvailable('singular') ?  AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel: strings.Position}</TableHeaderColumn>
						<TableHeaderColumn className="TextOverflow" title={strings.Start_Time} style={{ textAlign: "left", paddingLeft: 5, paddingRight: 5 }}>{strings.Start_Time}</TableHeaderColumn>
						<TableHeaderColumn className="TextOverflow" title={strings.End_Time} style={{ textAlign: "left", paddingLeft: 5, paddingRight: 5 }}>{strings.End_Time}</TableHeaderColumn>
						<TableHeaderColumn className="TextOverflow" title={strings.Breaks} style={{ textAlign: "left", paddingLeft: 5, paddingRight: 5, width: 40 }}>{strings.Breaks}</TableHeaderColumn>
						<TableHeaderColumn className="TextOverflow" title={strings.Early_In_Restriction_ShortTerm} style={{ textAlign: "left", paddingLeft: 5, paddingRight: 5, width: 50 }}>{strings.Early_In_Restriction_ShortTerm}</TableHeaderColumn>
						<TableHeaderColumn className="TextOverflow" title={strings.Differential_Pay_ShortTerm} style={{ textAlign: "left", paddingLeft: 5, paddingRight: 5, width: 40 }}>{strings.Differential_Pay_ShortTerm}</TableHeaderColumn>
					</TableRow>
				</TableHeader>
				<TableBody showRowHover={true} deselectOnClickaway={false}>
					{props.shiftTemplates.map((row, index) => {
						const name = row.Name,
							description = row.Description,
							hierarchyName = hierarchyHelper.getFullyQualifiedLevelNameById(row.HierarchyId),
							positionName = row.Position ? row.Position.Name : ""
						return (
							<TableRow
								data-intercom-target={index === 0 && "menu-Schedules-ShiftTemplates-OpenItemDetails"}
								key={index}
								selected={props.selectedShiftTemplates.find((item) => item.Id === row.Id) ? true : false}
							>
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer", paddingLeft: 5, paddingRight: 5 }}>
									<div className="TextOverflow" title={name}>{name}</div>
								</TableRowColumn>
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer", paddingLeft: 5, paddingRight: 5 }}>
									<div className="TextOverflow" title={description}>{description}</div>
								</TableRowColumn>
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer", paddingLeft: 5, paddingRight: 5 }}>
									<div className="TextOverflow" title={hierarchyName}>{hierarchyName}</div>
								</TableRowColumn>
								{AccountStore.getJobsEnabled() && [
									<TableRowColumn style={{ textAlign: "left", cursor: "pointer", paddingLeft: 5, paddingRight: 5 }} key="job">
										<div className="TextOverflow" title={row.JobName}>{row.JobName}</div>
									</TableRowColumn>,
									<TableRowColumn style={{ textAlign: "left", cursor: "pointer", paddingLeft: 5, paddingRight: 5 }} key="phase">
										<div className="TextOverflow" title={row.PhaseName}>{row.PhaseName}</div>
									</TableRowColumn>
								]}
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer", paddingLeft: 5, paddingRight: 5 }}>
									<div className="TextOverflow" title={positionName}>{positionName}</div>
								</TableRowColumn>
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer", paddingLeft: 5, paddingRight: 5 }}>{timeHelper.getTimeStringFormatFromSimpleTime(row.StartTime)}</TableRowColumn>
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer", paddingLeft: 5, paddingRight: 5 }}>{timeHelper.getTimeStringFormatFromSimpleTime(row.EndTime)}</TableRowColumn>
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer", paddingLeft: 5, paddingRight: 5, width: 40 }}>{row.Breaks.filter((item) => !item.Deleted).length}</TableRowColumn>
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer", paddingLeft: 5, paddingRight: 5, width: 50 }}>{row.EarlyPunchRestriction && row.EarlyPunchRestrictionMinutes}</TableRowColumn>
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer", paddingLeft: 5, paddingRight: 5, width: 40 }}>{row.DifferentialPayFactor}</TableRowColumn>
							</TableRow>
						)
					})}
				</TableBody>
			</Table>
		</div >
	)
}

export default ShiftTemplatesTable
